// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-offers-container {
    padding: 20px;
    border-radius: 8px;
    margin: 0 auto;
  }
  .heading-container h2 {
    text-align: left;
    color: #333;
}
.modal-dialog {
  position: absolute;
  top: 2.5vh;
  left: 10%;
  transform: translate(-50%, -50%);
  margin: 0;
}
@media (max-width:768px) {
  .modal-dialog {
    transition: transform .3s ease-out;
    transform: translate(-2%, 60px) !important;
    left: 7px;
}
}
html, body {
  height: 100%; /* Ensures the modal centers on the full page */
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5); /* Optional for a semi-transparent background */
}
input[type="datetime-local"]:focus {
  outline: none !important;
  box-shadow: none !important;
}


.create-group-offer-button2 {
    background-color:  #453D4D;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 63px;
    cursor: pointer;
    /* float: right; */
    /* margin-top: 1.5%; */
  }
  .group-offer-table-main{
    background-color: white;
    border-radius: 5px;
  
    margin-top: 20px;
  }
  .dropdown-menu{
    left: inherit !important;
    right: 0 !important;
  }
  .group-offers-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .group-offers-table th,
  .group-offers-table td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }
  
  .group-offers-table th {
    font-weight: bold;

  }
  .group-offers-table tbody{
    padding-top: 15px;
    padding-bottom: 151px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/pages/admin/BuyerSets/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,WAAW;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,SAAS;AACX;AACA;EACE;IACE,kCAAkC;IAClC,0CAA0C;IAC1C,SAAS;AACb;AACA;AACA;EACE,YAAY,EAAE,+CAA+C;AAC/D;AACA;EACE,oCAAoC,EAAE,+CAA+C;AACvF;AACA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;;AAGA;IACI,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,kBAAkB;;IAElB,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;;EAEnB;EACA;IACE,iBAAiB;IACjB,qBAAqB;EACvB","sourcesContent":[".group-offers-container {\n    padding: 20px;\n    border-radius: 8px;\n    margin: 0 auto;\n  }\n  .heading-container h2 {\n    text-align: left;\n    color: #333;\n}\n.modal-dialog {\n  position: absolute;\n  top: 2.5vh;\n  left: 10%;\n  transform: translate(-50%, -50%);\n  margin: 0;\n}\n@media (max-width:768px) {\n  .modal-dialog {\n    transition: transform .3s ease-out;\n    transform: translate(-2%, 60px) !important;\n    left: 7px;\n}\n}\nhtml, body {\n  height: 100%; /* Ensures the modal centers on the full page */\n}\n.modal-backdrop {\n  background-color: rgba(0, 0, 0, 0.5); /* Optional for a semi-transparent background */\n}\ninput[type=\"datetime-local\"]:focus {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n\n.create-group-offer-button2 {\n    background-color:  #453D4D;\n    color: white;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 63px;\n    cursor: pointer;\n    /* float: right; */\n    /* margin-top: 1.5%; */\n  }\n  .group-offer-table-main{\n    background-color: white;\n    border-radius: 5px;\n  \n    margin-top: 20px;\n  }\n  .dropdown-menu{\n    left: inherit !important;\n    right: 0 !important;\n  }\n  .group-offers-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .group-offers-table th,\n  .group-offers-table td {\n    padding: 10px;\n    text-align: left;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .group-offers-table th {\n    font-weight: bold;\n\n  }\n  .group-offers-table tbody{\n    padding-top: 15px;\n    padding-bottom: 151px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
